<template>
  <div id="startData">
    <div class="mainFixed" style="position:relative;top:0;width:calc(100% - 20px);">
      <!-- 公告发布 -->
      <div class="allSearch d_flex">
        <div class="startdataTop">
          <div class="announcement"></div>
          <div class="cement">{{$t('common.VersionStartupSettings')}}</div>
        </div>
      </div>
      <!-- 产品线 -->
      <div class="select">
        <dl style="display: flex; align-items: flex-start">
          <dd>
            <span class="product_line">{{nextMonth}}{{$t('common.VersionStartup')}}:</span>
          </dd>
          <dd>
            <button :disabled="!isCanClick.IsReadyForNextCycle" class="redButton m_l_10" style="margin-top: 44px;" @click="getsave()">{{isCanClick.IsReadyForNextCycle?$t('common.Startup'):'Reason：'+isCanClick.Reason}}</button>
          </dd>
        </dl>
      </div>

      <table class="allTable"
             cellspacing="0">
        <thead>
          <tr>
            <td class="w_3">{{$t('common.Version')}}</td>
            <td class="w_2">{{$t('common.StartDate')}}</td>

          </tr>
        </thead>
        <tbody>
          <template v-if="timeList && timeList.length !==0">
            <tr v-for="(item,index) in timeList"
                :key="index">
              <td class="w_2">{{item.YearMonth}}</td>
              <td class="w_3">{{item.StartDate}}</td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="2">{{$t('common.noData')}}</th>
          </tr>
        </tbody>
      </table>
      <page :totalPage='page'
            :page='offset'
            @on-getList="pageChange"
            v-if="timeList && timeList.length !==0"></page>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      postData: [],
      timeList: [],
      // 分页
      offset: 0,
      page: 0,
      nextMonth: '',
      isCanClick: {}
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.StartDateManagement')
  },
  created () {
    this.getCanClick()
    this.gettimeList()
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').addEventListener('click', closeMenu)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closeMenu)
  },
  methods: {
    getCanClick () {
      this.$axiox.get('/api/v1/admin/cycle/info').then(res => {
        if (res.data) {
          this.isCanClick = res.data
          this.nextMonth = this.$t('common.' + res.data.Month + 'M')
        }
      })
    },
    getsave () {
      if (this.isCanClick.IsReadyForNextCycle) {
        this.$axiox.get('/api/v1/admin/cycle').then(res => {
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.StartupSuccessfully'),
            stayTime: 5
          })
          this.getCanClick()
          this.gettimeList()
        })
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          content: this.isCanClick.Reason ? this.isCanClick.Reason : 'failed',
          stayTime: 5
        })
      }
    },
    gettimeList (pageIndex = 1, pageSize = 6) {
      this.$axiox.get(`/api/v1/admin/startsetting/list?pageIndex=${pageIndex}&pageSize=${pageSize}`).then(res => {
        this.timeList = res.data.items
        this.offset = res.data.offset
        this.page = res.data.pages
      })
    },
    pageChange (val) {
      this.gettimeList(val, 6)
    }
  }
}
function closeMenu () {}
</script>

<style>
#startData th {
  text-align: center;
  color: #8b8686;
  padding: 40px;
  font-size: 14px;
  font-weight: 400;
}
.startdataTop {
  display: flex;
  padding-top: 20px;
}
.announcement {
  width: 3px;
  height: 15px;
  background: #c50f3c;
}
.cement {
  color: #c50f3c;
  font-weight: bold;
  padding-left: 8px;
}
.product_line {
  display: inline-block;
  color: #000;
  padding: 50px 0px;
}
.select {
  padding-left: 50px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f1eaea;
}
.unload i {
  padding-right: 10px;
  vertical-align: middle;
  color: white;
}
#startData .allTable thead td {
  border-bottom: 2px solid #d68497;
  padding: 12px 0px 10px 80px;
}
#startData .allTable tbody td {
  padding: 22px 0px 22px 80px;
}
#startData .allTable {
  width: 100%;
}

#startData .allTable tbody tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
#startData .mainFixed {
  padding: 0 10px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/startData/startData.vue